import { Construction } from "lucide-react";
import { PageHeader } from "../../components/admin/PageHeader";

export default function ComingSoon({ title }) {
  return (
    <div data-testid="coming-soon-page">
      <PageHeader eyebrow="Coming soon" title={title} />
      <div className="rmm-card flex items-center gap-3 p-8 text-sm text-[#8C6A6C]">
        <Construction className="h-5 w-5 text-[#D4AF37]" /> This section will be available in a later phase.
      </div>
    </div>
  );
}
